import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class IdService {

	constructor() {
		for (var i = 0; i < 256; i++) { this.lut[i] = (i < 16 ? '0' : '') + (i).toString(16); }
	}

	/**
	 * Fast UUID generator, RFC4122 version 4 compliant.
	 * http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
	 **/
	private lut: string[] = [];
	private e7() {
		let lut = this.lut;
		var d0 = Math.random() * 0xffffffff | 0;
		var d1 = Math.random() * 0xffffffff | 0;
		var d2 = Math.random() * 0xffffffff | 0;
		var d3 = Math.random() * 0xffffffff | 0;
		return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
			lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
			lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
			lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
	}

	generateGuid() {
		if (window.isSecureContext) return crypto.randomUUID();
		console.warn('crypto.randomUUID() not available due to insecure context, using fallback implementation');
		return this.e7();
	}

	generateGuidWithoutDashes() {
		return this.removeDashes(this.generateGuid());
	}

	removeDashes = (guid: string) => guid.replace(/-/g, '')

	private generalId = 1;

	// useful when the app needs a unique id (number) that's unique for the lifetime of the app
	getNextGeneralId() {
		return this.generalId++;
	}
}